import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LuciGlobalSearchComponent } from './luci-global-search.component';
import {FormsModule} from '@angular/forms';
import {LuciTableModule} from '../luci-table/luci-table.module';
import {GlobalSearchFilterModule} from '../commons/pipes/global-search-filter/global-search-filter.module';



@NgModule({
  declarations: [LuciGlobalSearchComponent],
  exports: [LuciGlobalSearchComponent],
  imports: [
    CommonModule,
    FormsModule,
    LuciTableModule,
    GlobalSearchFilterModule
  ]
})
export class LuciGlobalSearchModule { }
